import { Alert } from 'antd';

export const DurationAlert = () => {
  return (
    <Alert
      showIcon
      type="warning"
      title={
        <span>
          脚本中的必须包含<span className="font-bold">时长和画面描述</span>
          相关的字眼，并且总时长需基本等于所填写的 时长，建议先点击
          <span className="font-bold">初始化脚本</span>后按格式填写
        </span>
      }
    ></Alert>
  );
};
